import React, {
    ReactElement,
} from 'react';
import {
    Routes,
    Route,
} from 'react-router-dom';
import LandingPage from 'service_approval_page/landing_page';
import ErrorPage from 'error_page';

/**
 * Component for service page. The service page consists of two sub-routes:
 * landing page and submission page
 *
 * @returns {ReactElement} the service page component.
 */

export default function ServiceApprovalPage() {
    return (
        <Routes>
            <Route exact path="/" element={<LandingPage />} />
            <Route exact path="*" element={<ErrorPage />} />
        </Routes>
    );
}
